import { useProcessFilter } from 'features/records/components/RecordFilters'
import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'
import { HighlightsWidgetAttributeItem } from 'features/views/LayoutEditor/widgets/HighlightsWidget/attributes/types'
import { HighlightsWidgetType } from 'features/views/LayoutEditor/widgets/HighlightsWidget/types'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

export function useHighlightsWidgetItems(widget: HighlightsWidgetType) {
    const { record, permissions } = useRecordManagerContext()
    const { fields, isEditing } = useLayoutEditorContext()

    const fieldsByApiName = fields.reduce((acc, f) => {
        return acc.set(f.api_name, f)
    }, new Map<string, FieldDto>())
    const widgetItems = widget.attrs.items ?? []
    const displayedItems: HighlightsWidgetAttributeItem[] = widgetItems.reduce((acc, f) => {
        const field = fieldsByApiName.get(f.apiName)
        if (field) {
            acc.push({
                ...f,
                field,
            })
        }

        return acc
    }, [] as HighlightsWidgetAttributeItem[])

    const processFilter = useProcessFilter()
    let visibleItems: HighlightsWidgetAttributeItem[] = displayedItems
    if (!isEditing) {
        const fieldsWithReadPerms = new Set(permissions.canReadFields)

        // If not editing, filter fields based on conditions.
        visibleItems = visibleItems.filter((f) => {
            if (!fieldsWithReadPerms.has(f.apiName)) return false

            if (!record && f.conditions.length) return false
            if (!record && !f.conditions.length) return true

            const filteredData = processFilter([record!], f.conditions)

            return filteredData.length > 0
        })
    }

    return useDeepEqualsMemoValue({
        displayedItems,
        visibleItems,
    })
}
